export const suggestionsForTermInMultipleCategoriesQuery = `
  {
   "query": {
    "bool": {
      "must": [
        {
          "terms": {
            "category": [<%=categories%>]
          }
        }
        <%=termSubquery%>
      ]
    }
  },
  "aggs": {
    "top_values": {
      "terms": {
         "field": "value.precise",
        "size": <%=maxCount%>
      },
      "aggs": {
        "known_categories": {
          "terms": {
             "field": "category",
              "size": <%=maxCount%>
          }
        }
      }
    }
  },
  "size": <%=maxCount%>
}
`;
